module.exports = __webpack_public_path__ + "img/step2.b9cb905.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/step2.svg
// module id = ./assets/assistant/step2.svg
// module chunks = 10